// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3lREo","footer":"ModalInfo_footer__BxRxt"};